import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="has-different-percent"
export default class extends Controller {
  static targets = [ "applicable_percent" ]

  toggle(event) {
    const isChecked = event.target.checked;
    this.toggleDisabledState(this.applicable_percentTarget, isChecked);
  }

  toggleDisabledState(target, isChecked) {
    target.disabled = !isChecked;
    if (isChecked) {
      target.classList.remove('bg-gray-200', 'cursor-not-allowed');
    } else {
      target.classList.add('bg-gray-200', 'cursor-not-allowed');
      if (target.type === "checkbox") {
        target.checked = false;
      } else {
        target.value = "";
      }
    }
  }
}
